import SIGNALR from '@/libs/signalR/vuexStore/storeActions';

const ACTIONS = {
  SET_BEARER_TOKEN: 'setBearerToken',
  SET_RUN_INFO: 'setRunInfo',
  SET_RUN_DOCUMENTS: 'setRunDocuments',
  SET_SNACKBAR: 'setSnackbar',
  SET_CURRENT_EXERCISE_AND_CANDIDATE: 'setCurrentExerciseAndParticipant',
  SET_CURRENT_INTERVIEW: 'setCurrentInterview',
  REMOVE_CURRENT_INTERVIEW: 'removeCurrentInterview',
  SET_USER: 'setUser',
  SET_IS_LOADING: 'setIsLoading',
  SET_ASSESSMENTS: 'setAssessments',
  SET_SINGLE_ASSESSMENT: 'setSingleAssessment',
  UPDATE_ASSESSMENTS: 'updateAssessments',
  SET_CANDIDATE_IMAGE: 'setParticipantImage',
  CLEAR_STATE: 'clearState',
  PUSH_INTERVIEWS: 'pushInterviews',
  PUSH_OBSERVATIONS: 'pushObservations',
  REMOVE_OBSERVATION: 'removeObservation',
  UPDATE_OBSERVATIONS: 'updateObservations',
  UPDATE_RUNSTATE: 'updateRunState',
  SET_CURRENT_EXERCISE_DOCUMENTS: 'setCurrentExerciseDocuments',
  SET_EXERCISE_DOCUMENTS_LOADING_STATE: 'setExerciseDocumentsLoadingState',
  SET_SINGLE_TMP_ASSESSMENT: 'setSingleTmpAssessment',
  UPDATE_TMP_ASSESSMENT: 'updateTmpAssessment',
  SET_CURRENT_CANDIDATE: 'setCurrentParticipant',

  // import the signalR Store Actions
  ...SIGNALR
}

export default ACTIONS;
